<template>
    <div>
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            {{ data.kind }} - {{ data.brand }}
            <div class="mt-2">
                <!-- Harga Dasar: <strong>Rp. {{ $helper.formatThousand(data.base_price) }}</strong> -->
            </div>
            <b-table-simple class="mt-2" bordered responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Batangan</b-th>
                        <b-th>Grade S</b-th>
                        <b-th>Grade B</b-th>
                        <b-th>Grade C</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>
                            <div>Rp. {{ $helper.formatThousand(data.adj_batangan) }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.adj_s == null" class="text-muted">Tidak ada</div>
                            <div v-else>Rp. {{ $helper.formatThousand(data.adj_s) }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.adj_b == null" class="text-muted">Rumus Umum</div>
                            <div v-else>Rp. {{ $helper.formatThousand(data.adj_b) }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.adj_c == null" class="text-muted">Rumus Umum</div>
                            <div v-else>Rp. {{ $helper.formatThousand(data.adj_c) }}</div>
                        </b-td>
                        <!-- <b-td>
                            <div v-if="data.adj_d == null" class="text-muted">Rumus Umum</div>
                            <div v-else>Rp. {{ $helper.formatThousand(data.adj_d) }}</div>
                        </b-td> -->
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <strong>Harga</strong>
            <b-table-simple class="mt-2" bordered responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Spek</b-th>
                        <b-th>Harga</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-if="data.specs.length != 0">
                    <b-tr v-for="spec in data.specs" v-bind:key="spec.name">
                        <b-td>{{ spec.name }}</b-td>
                        <b-td>Rp. {{ $helper.formatThousand(spec.adj) }}</b-td>
                    </b-tr>
                </b-tbody>
                <b-tbody v-else>
                    <b-tr>
                        <b-td colspan="2">Tidak ada spek diluar ORI</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <strong>Dimensi & Berat</strong>
            <b-table-simple class="mt-2" bordered responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Panjang (cm)</b-th>
                        <b-th>Lebar (cm)</b-th>
                        <b-th>Tinggi (cm)</b-th>
                        <b-th>Berat (gr)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>
                            <div v-if="data.length == null" class="text-muted">Tidak ada</div>
                            <div v-else>{{ data.length }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.width == null" class="text-muted">Tidak ada</div>
                            <div v-else>{{ data.width }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.height == null" class="text-muted">Tidak ada</div>
                            <div v-else>{{ data.height }}</div>
                        </b-td>
                        <b-td>
                            <div v-if="data.weight == null" class="text-muted">Tidak ada</div>
                            <div v-else>{{ data.weight }}</div>
                        </b-td>
                        <!-- <b-td>
                            <div v-if="data.adj_d == null" class="text-muted">Rumus Umum</div>
                            <div v-else>Rp. {{ $helper.formatThousand(data.adj_d) }}</div>
                        </b-td> -->
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <div class="mt-4 text-right">
                <router-link :to="'/master/barang/' + segment + '/' + id">
                    <b-button variant="warning">
                        <i class="fa fa-pencil mr-2" />Edit
                    </b-button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,

            data: {
                specs: []
            }

        }
    },
    props: {
        segment: { type: String, required: true },
        id: { type: Number, required: true }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.$axios.get(`master/item/${this.segment}/${this.id}`).then(res => {

                this.initStatus = 1
                this.data = res.data.data

            })
            .catch(error => this.initStatus = -1)

        }

    },
    created() {
        this.init()
    }
}
</script>

<style>

</style>
